import * as Tooltip from '@radix-ui/react-tooltip';
import cn from 'classnames';
import React, { useContext } from 'react';

import {
  ToothChartItemClickHandler,
  ToothChartSize,
  ToothItem,
} from '../../config/types';
import { ToothChartItem } from '../ToothChartItem/ToothChartItem';
import { ToothChartContext } from '../ToothChartRoot/ToothChartRoot';

import styles from './ToothChartSuperItem.module.scss';

const sizeStyles: Record<ToothChartSize, string> = {
  default: styles.sizeDefault,
  small: styles.sizeSmall,
  mobile: styles.sizeMobile,
};

type ToothChartSuperItemProps = ToothItem & {
  className?: string;
  supernumeraryIndex?: number;
  blackAndWhite?: boolean;
  onClick?: ToothChartItemClickHandler;
  isApproved?: boolean;
  preview?: boolean;
};

const InternalToothChartSuperItem = (props: ToothChartSuperItemProps) => {
  const {
    className,
    id,
    status,
    active,
    isLowerJaw,
    ISONumber,
    blackAndWhite = false,
    childItems,
    gridArea,
    preview,
    onClick,
    isApproved,
    isRemoved,
  } = props;

  const size = useContext(ToothChartContext);

  const mainItemIsActive = active || childItems?.some((item) => item.active);

  return (
    <Tooltip.Root delayDuration={0}>
      <Tooltip.Trigger asChild>
        <ToothChartItem
          id={id}
          status={status}
          isLowerJaw={isLowerJaw}
          ISONumber={ISONumber}
          active={Boolean(mainItemIsActive)}
          childItems={childItems}
          blackAndWhite={blackAndWhite}
          gridArea={gridArea}
          isRemoved={isRemoved}
          isApproved={isApproved}
          preview={preview}
        />
      </Tooltip.Trigger>

      <Tooltip.Portal>
        <Tooltip.Content className={styles.content} sideOffset={5}>
          <div className={cn(className, styles.container, sizeStyles[size])}>
            <ToothChartItem
              id={id}
              status={status}
              isLowerJaw={isLowerJaw}
              ISONumber={ISONumber}
              active={active}
              blackAndWhite={blackAndWhite}
              onClick={onClick}
              gridArea={gridArea}
              isRemoved={isRemoved}
              isApproved={isApproved}
              preview={preview}
            />

            {childItems?.map((childItem) => (
              <ToothChartItem
                supernumeraryIndex={childItem.supernumeraryIndex}
                key={childItem.id}
                id={childItem.id}
                status={childItem.status}
                isLowerJaw={childItem.isLowerJaw}
                ISONumber={childItem.ISONumber}
                active={childItem.active}
                blackAndWhite={blackAndWhite}
                onClick={onClick}
                gridArea={gridArea}
                isRemoved={isRemoved}
                isApproved={isApproved}
                preview={preview}
              />
            ))}
          </div>

          <Tooltip.Arrow className={styles.arrow} />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
};

export const ToothChartSuperItem = React.memo(InternalToothChartSuperItem);
